import ProductCarousel from './ProductCarousel';
import { productCategories } from '@/mocks/products';

export default function ProductShowcase() {
  return (
    <section className="py-12 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-12 xl:px-20 mb-8 md:mb-12">
        <div className="max-w-3xl">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 tracking-tight mb-4">
            Browse Featured Products
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            Explore our curated selection across every category. Click any item to visit the main store and complete your purchase.
          </p>
        </div>
      </div>

      <div className="border-t border-background-200">
        {productCategories.map((category, index) => (
          <div
            key={category.id}
            className={`${index % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}
          >
            <ProductCarousel categoryName={category.name} products={category.products} />
          </div>
        ))}
      </div>

      <div className="px-4 md:px-6 lg:px-12 xl:px-20 mt-12 md:mt-16">
        <div className="bg-primary-50 rounded-xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-2">
              Want to see more?
            </h3>
            <p className="text-foreground-600 text-sm md:text-base">
              Visit the full store for thousands more products across all categories.
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold px-6 py-3 rounded-md transition-all duration-300 hover:scale-105 flex items-center gap-2"
          >
            <span>Visit Full Store</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line" />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}